import { vmFacebookLoginModal, vmFacebookShareModal, vmFollowPopularCompany } from './components';
import { componentMountSelectors, $componentMountElements } from '../elements';

/**
 * マウントしてexportするラッパー
 */
document.addEventListener('DOMContentLoaded', () => {
  if ($componentMountElements.followModal !== null) {
    vmFollowPopularCompany.$mount(componentMountSelectors.followModal);
  }

  if ($componentMountElements.shareModal !== null) {
    // レンダリング前にマウントする要素から企業名を取得
    const companyName = $componentMountElements.shareModal.getAttribute('data-company-name');
    vmFacebookShareModal.$mount(componentMountSelectors.shareModal);
    vmFacebookShareModal.$data.companyName = companyName;
  }

  if ($componentMountElements.loginModal !== null) {
    vmFacebookLoginModal.$mount(componentMountSelectors.loginModal);
  }
});

export {
  vmFacebookLoginModal,
  vmFacebookShareModal,
  vmFollowPopularCompany
};
